import { Organisation } from "modules/Reports/hooks/useGetOrganisations"

export function getUserOrganisationId(
  organisation: string | null
): string | null {
  const org: Organisation = organisation ? JSON.parse(organisation) : null
  return org ? org.value : null
}
